import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'semantic-ui-react';

export default function ResponsiveTable({ children, ...props }) {
    return (
        <div style={{ overflowX: 'auto' }}>
            <Table {...props}>{children}</Table>
        </div>
    );
}

ResponsiveTable.propTypes = {
    children: PropTypes.node
};
